/**
 * This file will provide the application context ("app") that other objects
 * will add themselves and reference for other objects.
 *
 * This is, in effect, the application namespace.
 *
 * As other files "require" this file and update the properties, etc., other
 * files will be able to access these properties and objects.
 */

const packageJson = require('../../package.json');

window.useLocal = true;

const app = {
    useLocal: true,

    name: "Coactive",
    helpSiteLink: "https://coactiveapps.com",
    version: packageJson.version,
    apiContext: false,
    mobile: false,
    browser: true,

    dv: {},
    config: {
        socketUrl: process.env.NODE_ENV === 'development'
            ? 'ws://localhost:8080/clientSocket'
           : process.env.CLIENT_SOCKET_URL || (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host + '/clientSocket',
    },
};
module.exports = app;
module.exports.default = app;
